import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import { Wrapper } from '@catalogo/theme-wrapper';
import Menu from '@catalogo/ui-americanas-desktop-svg/menu-desk.svg';
import ArrowDown from '@catalogo/ui-americanas-desktop-svg/arrow.svg';
import withMenu from '@catalogo/service-americanas-header/src/hocs/menuDesk';
import Overlay from '@catalogo/theme-overlay';
import { timerEventMetric } from '@catalogo/service-americanas-header/src/helpers/metrics';
import DepartmentsDropdown from './components/main-departments';
import DepartmentList from './components/department-list';

let timeout = 0;
export const DepartmentMenu = ({
  config,
  trendingDepartments,
  departmentsTree,
  allDepartments,
  dispatchMetrics,
  history,
  fetchMenu,
  variables,
  ...props
}) => {
  const [isDepartmentHovered, setIsDepartmentHovered] = useState(false);
  const [canMenuDepartmentMetrics, setCanMenuDepartmentMetrics] = useState(true);
  const mainUrl = `${getIn(config, ['domainUrl'])}${getIn(history, ['location', 'pathname'], '')}`;
  const isOpenMenu = () => isDepartmentHovered && departmentsTree.length > 0;
  useEffect(
    () => () => {
      clearTimeout(timeout);
    },
    []
  );

  return (
    <DepartmentContainer>
      <WrapperUI>
        <MenuWrapper
          onMouseEnter={() => {
            setIsDepartmentHovered(true);
            fetchMenu({ variables });
            if (canMenuDepartmentMetrics) {
              timeout = timerEventMetric(dispatchMetrics, 'menutemp', 'menu-header', 'menu-lateral', () =>
                setCanMenuDepartmentMetrics(false)
              );
            }
          }}
          onMouseLeave={() => {
            setIsDepartmentHovered(false);
            clearTimeout(timeout);
          }}
          zIndex={isOpenMenu() ? 10 : 1}
        >
          <ButtonWrapper zIndex={isOpenMenu() ? 10 : 0}>
            <MenuUI />
            <ButtonUI className="button">compre por departamento</ButtonUI>
            <ArrowDownUI />
          </ButtonWrapper>

          <DepartmentsDropdown
            departmentsTree={departmentsTree}
            allDepartments={allDepartments.length > 0 ? allDepartments[0].children : []}
            isHovered={isOpenMenu()}
            dispatchMetrics={dispatchMetrics}
            {...props}
          />
        </MenuWrapper>
        <DepartmentList trendingDepartments={trendingDepartments} mainUrl={mainUrl} dispatchMetrics={dispatchMetrics} />
        <Overlay showOverlay={isOpenMenu()} zIndex={isOpenMenu() ? 9 : 0} />
      </WrapperUI>
    </DepartmentContainer>
  );
};

export default withMenu(DepartmentMenu);

const DepartmentContainer = styled.div`
  background: #fff;
  width: 100%;

  @media screen and (max-width: 1260px) {
    padding: 0 30px;
  }
`;

const WrapperUI = styled(Wrapper)`
  display: flex;
  align-items: center;
  height: 40px;
  position: relative;
`;

const MenuUI = styled(Menu)`
  height: 16px;
  width: 24px;
  fill: #333;

  path {
    transition: fill 0.3s;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  position: relative;
  z-index: ${({ zIndex }) => zIndex};
  background-color: #fff;
  transform: translateX(-12px);
  padding-left: 12px;
  width: 245px;
`;

const ButtonUI = styled.button`
  font-weight: bold;
  font-size: 13.6px;
  color: ${({ theme }) => theme.grey.darker};
  background: none;
  border: none;
  flex-wrap: nowrap;
  padding: 0 8px;
  transition: color 0.3s;
  margin: 0;
  font-family: Arial, sans-serif;
`;

const ArrowDownUI = styled(ArrowDown)`
  height: 5px;
  width: 10px;
  fill: #333;
  transition: fill 0.3s, transform 0.3s;
`;

const MenuWrapper = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  z-index: ${({ zIndex }) => zIndex};
  width: 100%;
  max-width: 245px;
  height: 40px;

  &:hover {
    ${ButtonUI} {
      color: ${({ theme }) => theme.primaryColor};
    }

    ${ArrowDownUI} {
      fill: ${({ theme }) => theme.primaryColor};
      transform: rotate(180deg);
    }

    ${MenuUI} path {
      fill: ${({ theme }) => theme.primaryColor};
    }
  }
`;
